<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form
        ref="organeForm"
        @submit="updateOrgane"
        :validation-schema="organeSchema"
      >
        <div class="row">
          <!-- Nom de l’organe -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom de l'organe <span class="text-danger">*</span>
              </label>
              <Field
                name="nom"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom de l'organe"
                v-model="organe.nom"
              />
              <ErrorMessage name="nom" class="text-danger" />
            </div>
          </div>

          <!-- Liste des postes -->
          <div class="col-md-12">
            <div class="d-flex justify-content-between align-items-center mb-15">
              <h5 class="fw-semibold text-black">Postes de l’organe</h5>
            </div>
          </div>

          <div
            v-for="(poste, index) in postes"
            :key="index"
            class="col-md-12 border rounded p-15 mb-15 bg-light"
          >
            <h6 class="fw-bold mb-10 text-primary">Poste {{ index + 1 }}</h6>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-10">
                  <label class="d-block text-black fw-semibold mb-5">
                    Nom du poste <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="poste.nomPoste"
                    type="text"
                    class="form-control shadow-none text-black"
                    placeholder="Ex: Maire, Conseiller..."
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group mb-10">
                  <label class="d-block text-black fw-semibold mb-5">
                    Numéro d'ordre
                  </label>
                  <input
                    v-model.number="poste.numeroOrdre"
                    type="number"
                    min="1"
                    class="form-control shadow-none text-black bg-light" 
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-10">
                  <label class="d-block text-black fw-semibold mb-5">
                    Arrondissement <span class="text-danger"></span>
                  </label>
                  <Multiselect
                    v-model="poste.arrondissementId"
                    :options="arrondissementsOptions"
                    placeholder="Sélectionner un arrondissement"
                    label="label"
                    track-by="value"
                    :searchable="true"
                    class="shadow-none"
                  />
                </div>
              </div>

              <div class="col-md-1 d-flex align-items-end drop">
                <button
                  type="button"
                  class="btn btn-danger btn-sm mb-15"
                  @click="supprimerPoste(index)"
                >
                  <i class="flaticon-delete"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-end mb-15">
            <button
                type="button"
                class="btn btn-outline-success btn-sm"
                @click="ajouterPoste"
            >
                + Ajouter un poste
            </button>
        </div>

          <div class="col-md-12 mt-15">
            <div class="d-flex align-items-center">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 bg-success"
                type="submit"
              >
                Mettre à jour
              </button>
              <router-link
                to="/liste-organes"
                class="btn btn-danger transition border-0 lh-1 fw-medium"
              >
                <i class="flaticon-delete lh-1 me-1"></i> Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import ApiService from "@/services/ApiService";
import { success, error } from "@/utils/utils";
import { useRouter, useRoute } from "vue-router";
import Swal from 'sweetalert2';

import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "EditOrgane",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const organe = ref<any>({ nom: "", postes: [] });
    const postes = ref<any[]>([]);
    const arrondissementsOptions = ref<any[]>([]);

    const organeSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom de l'organe est obligatoire"),
    });

    const fetchArrondissements = async () => {
      try {
        const response = await ApiService.get("/all/arrondissements");
        arrondissementsOptions.value = response.data.data.data.map((arr: any) => ({
          value: arr.id,
          label: `${arr.libelle}`,
        }));
      } catch (err) {
        error("Erreur lors du chargement des arrondissements");
      }
    };

    const fetchOrgane = async () => {
  try {
    const { data } = await ApiService.get(`/organes/${route.params.id}`);
    console.log("ttttt",data)
    organe.value = data.data;
    postes.value = organe.value.postes.map((poste: any) => {
      const arrondissementObj = arrondissementsOptions.value.find(
        (a) => a.value === poste.arrondissement?.id
      );
      return {
        ...poste,
        arrondissementId: poste.arrondissement?.id || null, 
      };
    }); 
    console.log("mes postes",postes)
  } catch (err: any) {
    error(err.response?.data?.message || "Erreur lors du chargement de l'organe");
  }
};


    const ajouterPoste = () => {
      postes.value.push({ nomPoste: "", numeroOrdre: postes.value.length + 1, arrondissementId: null });
    };

    const supprimerPoste = async (index: number) => {
      const result = await Swal.fire({
      title: "Confirmation",
      text: "Voulez-vous vraiment supprimer ce poste ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Oui, supprimer",
      cancelButtonText: "Annuler",
    });

    if (result.isConfirmed) {
      postes.value.splice(index, 1);
      Swal.fire("Supprimé !", "Le poste a été supprimé avec succès.", "success");
    }
  };

    const updateOrgane = async () => {
      if (postes.value.length < 1) {
        error("Veuillez ajouter au moins un poste !");
        return;
      }

      const payload = {
        nom: organe.value.nom,
        postes: postes.value.map((p) => ({
          id: p.id, 
          nomPoste: p.nomPoste,
          numeroOrdre: p.numeroOrdre,
          arrondissementId: p.arrondissementId})),
      };
      console.log("les valeurs envoyés", payload);

      try {
        await ApiService.put(`/organe/${route.params.id}`, payload);
        success("Organe mis à jour avec succès !");
        router.push({ name: "liste-organes" });
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la mise à jour");
      }
    };

    onMounted(async () => {

      await fetchArrondissements();
      await fetchOrgane();
    });

    return { organeSchema, organe, postes, arrondissementsOptions, ajouterPoste, supprimerPoste, updateOrgane };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
